/**
 * @file: customIssueInfluence.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { DefectiveLevel } from '@euler/model';
import { PredefinedDefectiveClass } from '@euler/model/task-detail';

export type CustomIssueInfluenceFactor = {
  value: number;
  title: string;
  description: string;
  defectiveClass: PredefinedDefectiveClass;
  defectiveLevel: DefectiveLevel;
};

export const CustomIssueInfluenceFactors: CustomIssueInfluenceFactor[] = [
  {
    value: 10,
    title: '安全',
    description: '该部位损坏或故障将影响汽车的行驶安全性',
    defectiveClass: 'safety',
    defectiveLevel: DefectiveLevel.Urgent,
  },
  {
    value: 8,
    title: '动力',
    description: ' 该部位损坏或故障将影响汽车的动力造成动力不足',
    defectiveClass: 'power',
    defectiveLevel: DefectiveLevel.Urgent,
  },
  {
    value: 4,
    title: '经济',
    description: '该部位损坏或故障将影响汽车的燃油经济性',
    defectiveClass: 'economic',
    defectiveLevel: DefectiveLevel.Warning,
  },
  {
    value: 3,
    title: '舒适',
    description: '该部位损坏或故障将影响汽车的舒适性',
    defectiveClass: 'comfort',
    defectiveLevel: DefectiveLevel.Defective,
  },
  {
    value: 5,
    title: '其他',
    description: '该部位损坏或存在故障且可能存在一定影响',
    defectiveClass: 'other',
    defectiveLevel: DefectiveLevel.Warning,
  },
];

export const matchCustomIssueInfluenceFactor = (
  value: number | undefined,
  defectiveClass?: string,
): CustomIssueInfluenceFactor | undefined => {
  if (value == null) return undefined;

  let item: CustomIssueInfluenceFactor | undefined = undefined;

  if (defectiveClass != null) {
    item = CustomIssueInfluenceFactors.find(
      x => x.defectiveClass === defectiveClass,
    );
  }

  if (item == null) {
    item = CustomIssueInfluenceFactors.find(x => x.value === value);
  }
  if (item) return item;

  return {
    value,
    title: '其他',
    description: '该部位损坏或存在故障且可能存在一定影响',
    defectiveClass: 'other',
    defectiveLevel: DefectiveLevel.Warning,
  };
};
